import React, { useState, useContext} from 'react';
import {Button, Card , Icon , Label, Image, Popup } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import moment from 'moment';

import { AuthContext } from '../context/auth';

import { LikeButton } from './LikeButton';

import { DeleteButton } from '../common/DeleteButton';




const PostCard = ({ post: {id, body ,createdAt, username, likeCount, likes, comments, commentCount } }) => {

    // generate random number 1 to 10
 
    let seed = Math.floor(Math.random() * 10) + 1;


    const { user } = useContext(AuthContext);
    return(
        <Card fluid>
            <Card.Content>
                <Image
                floated='right'
                size='mini'
                src= {`https://avatars.dicebear.com/api/pixel-art/${seed}.svg`}
                />
                <Card.Header>{username}</Card.Header>
                <Card.Meta as={Link} to={`/posts/${id}`}>{moment(createdAt).fromNow(true)}</Card.Meta>
                <Card.Description>
                {body}
                </Card.Description>
            </Card.Content>
            <Card.Content  extra>
            <LikeButton 
            user = {user} 
            post = {{id, likeCount, likes}}
            />
              <Popup 
              content='Comment on the post' 
              inverted
              trigger={            
                <Button as='div' labelPosition='right' as ={Link} to={`/posts/${id}`} >
                    <Button color='blue' basic>
                        <Icon name='comments' />
                    </Button>
                    <Label as='a' basic color='blue' pointing='left'>
                        {commentCount}
                    </Label>
                </Button>
                }
               />
             { user && user.username === username && (
                <DeleteButton postId={id}/>

             )}
            </Card.Content>
        </Card>
    )
};

export default PostCard;